import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useLanguage } from '../../context/LanguageContext'

/**
 * Shared shell for portal pages — header with logo, user info, sign out,
 * and a "Back to dashboard" link for setup pages.
 */
export default function PortalShell({ children, showBackLink = true }) {
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  const { t } = useLanguage()

  function handleSignOut() {
    logout()
    navigate('/login')
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <header style={{
        background: '#fff',
        borderBottom: '1px solid var(--card-border)',
        padding: '14px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Link to="/portal" style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/integolf-logo.svg" alt="InteGolf" style={{ height: 32 }} />
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>
            {user?.first_name} {user?.last_name}
          </span>
          <button
            onClick={handleSignOut}
            style={{
              background: 'transparent', border: 'none',
              color: 'var(--text-muted)', cursor: 'pointer',
              fontSize: 13, fontWeight: 500,
            }}
          >
            {t('sp_sign_out', 'Sign out')}
          </button>
        </div>
      </header>

      {/* Back-to-dashboard button rendered just above the page content so it's
          right where the user's eye lands when they want to navigate away.
          Uses a wide max-width so it lines up with whatever page is rendered
          (pages use 900-1100 max-widths). */}
      {showBackLink && (
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 20px 0' }}>
          <Link
            to="/portal"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '8px 14px',
              borderRadius: 6,
              background: 'var(--brand-50)',
              color: 'var(--brand-700)',
              border: '1px solid var(--brand-200)',
              fontSize: 13,
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'all 0.15s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'var(--brand-100)'
              e.currentTarget.style.borderColor = 'var(--brand-300)'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'var(--brand-50)'
              e.currentTarget.style.borderColor = 'var(--brand-200)'
            }}
          >
            <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden="true">←</span>
            <span>{t('dashboard', 'Dashboard')}</span>
          </Link>
        </div>
      )}

      {children}
    </div>
  )
}
